import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DeliveryCostRuleInputDto } from '../model/deliveryCostRuleInputDto';
import { DeliveryCostRuleOutputDto } from '../model/deliveryCostRuleOutputDto';
import { DeliveryCostRuleUpdateDto } from '../model/deliveryCostRuleUpdateDto';

@Injectable({
  providedIn: 'root',
})
export class DeliveryCostRuleService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/DeliveryCostRule`;
  private readonly headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  });

  constructor(private http: HttpClient) {}

  /**
   * Get all delivery cost rules
   */
  getAll(): Observable<DeliveryCostRuleOutputDto[]> {
    const url = `${this.baseUrl}/GetAll`;
    return this.http.get<DeliveryCostRuleOutputDto[]>(url, { headers: this.headers });
  }

  /**
   * Get delivery cost rule by ID
   * @param id The ID of the delivery cost rule
   */
  getById(id: number): Observable<DeliveryCostRuleOutputDto> {
    const url = `${this.baseUrl}/GetById`;
    return this.http.get<DeliveryCostRuleOutputDto>(`${url}?id=${id}`, { headers: this.headers });
  }

  /**
   * Create a new delivery cost rule
   * @param dto The delivery cost rule data
   */
  create(dto: DeliveryCostRuleInputDto): Observable<number> {
    const url = `${this.baseUrl}/Post`;
    return this.http.post<number>(url, dto, { headers: this.headers });
  }

  /**
   * Update an existing delivery cost rule
   * @param dto The updated delivery cost rule data
   */
  update(dto: DeliveryCostRuleUpdateDto): Observable<DeliveryCostRuleOutputDto> {
    const url = `${this.baseUrl}/Put`;
    return this.http.put<DeliveryCostRuleOutputDto>(url, dto, { headers: this.headers });
  }

  /**
   * Delete a delivery cost rule
   * @param id The ID of the delivery cost rule to delete
   */
  delete(id: number): Observable<boolean> {
    const url = `${this.baseUrl}/Delete`;
    return this.http.delete<boolean>(`${url}?id=${id}`, { headers: this.headers });
  }

  // Strict response type wrappers for type safety
  private getResponseData<T>(res: any): T {
    return res || {} as T;
  }

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return new Observable(observer => {
      observer.error(error);
      observer.complete();
    });
  }
}
